<h1>Teams</h1>
<button (click)="checkAuth()">
  Who Am I
</button>
